import { useState } from 'react';

export default function Galeria() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [activeFilter, setActiveFilter] = useState('todos');

  const categorias = [
    { id: 'todos', label: 'Todos' },
    { id: 'capacitaciones', label: 'Capacitaciones' },
    { id: 'eventos', label: 'Eventos' },
    { id: 'ferias', label: 'Ferias' },
    { id: 'talleres', label: 'Talleres' }
  ];

  const galeria = [
    {
      id: 1,
      categoria: 'capacitaciones',
      titulo: 'Capacitación en Gestión Financiera',
      fecha: 'Marzo 2024',
      descripcion: 'Más de 45 empresarios participaron en este taller intensivo sobre finanzas empresariales.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/c5a9d5db519fe8a1dc2e06d3ae47a244.jpeg'
    },
    {
      id: 2,
      categoria: 'ferias',
      titulo: 'Feria MIPYME Valle de Sula 2024',
      fecha: 'Febrero 2024',
      descripcion: 'Gran exposición comercial con más de 80 emprendedores mostrando sus productos.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/bd3e2d70dc9b6e06536adac56a24a0c4.jpeg'
    },
    {
      id: 3,
      categoria: 'talleres',
      titulo: 'Taller de Marketing Digital',
      fecha: 'Enero 2024',
      descripcion: 'Emprendedores aprendiendo estrategias de redes sociales y comercio electrónico.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/9bfb92371634dfe811a6a67bd45bb668.jpeg'
    },
    {
      id: 4,
      categoria: 'eventos',
      titulo: 'Ceremonia de Graduación Empresarial',
      fecha: 'Diciembre 2023',
      descripcion: '120 empresarios recibieron sus certificados del programa de formación empresarial.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/83ba56acb820c3a3abdf87f9acd52d52.jpeg'
    },
    {
      id: 5,
      categoria: 'capacitaciones',
      titulo: 'Programa de Formalización de Negocios',
      fecha: 'Noviembre 2023',
      descripcion: 'Sesión informativa sobre requisitos legales y beneficios de la formalización.',
      imagen: 'https://public.readdy.ai/ai/img_res/30aa455ad7d96f2bb2f6761de8ca17a4.jpg'
    },
    {
      id: 6,
      categoria: 'talleres',
      titulo: 'Taller de Plan de Negocios',
      fecha: 'Octubre 2023',
      descripcion: 'Emprendedores desarrollando sus planes de negocio con asesoría personalizada.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/ae8090b97bf5cd87ef4fdeb4bba0c8bc.jpeg'
    },
    {
      id: 7,
      categoria: 'eventos',
      titulo: 'Networking Empresarial',
      fecha: 'Septiembre 2023',
      descripcion: 'Encuentro de empresarios para crear alianzas y oportunidades de negocio.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/41be291daffeff650d3bf24780bc68af.jpeg'
    },
    {
      id: 8,
      categoria: 'ferias',
      titulo: 'Expo Emprendedores Honduras',
      fecha: 'Agosto 2023',
      descripcion: 'Participación destacada de MIPYMES del Valle de Sula en feria nacional.',
      imagen: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/2560b214f1613a55c8562bbbf055ff2f.png'
    },
    {
      id: 9,
      categoria: 'capacitaciones',
      titulo: 'Curso de Atención al Cliente',
      fecha: 'Julio 2023',
      descripcion: 'Formación en técnicas de servicio y fidelización de clientes.',
      imagen: 'https://readdy.ai/api/search-image?query=customer%20service%20training%20workshop%20honduran%20business%20owners%20learning%20sales%20techniques%20role%20playing%20exercises%20professional%20trainer%20modern%20classroom%20setting%20interactive%20session%20clean%20background&width=800&height=600&seq=galeria-atencion-cliente-001&orientation=landscape'
    }
  ];

  const filteredGaleria = activeFilter === 'todos' 
    ? galeria 
    : galeria.filter(item => item.categoria === activeFilter);

  const closeModal = () => setSelectedImage(null);

  const navigateImage = (direction: 'prev' | 'next') => {
    if (selectedImage === null) return;
    const currentIndex = filteredGaleria.findIndex(item => item.id === selectedImage);
    if (direction === 'prev') {
      const newIndex = currentIndex === 0 ? filteredGaleria.length - 1 : currentIndex - 1;
      setSelectedImage(filteredGaleria[newIndex].id);
    } else {
      const newIndex = currentIndex === filteredGaleria.length - 1 ? 0 : currentIndex + 1;
      setSelectedImage(filteredGaleria[newIndex].id);
    }
  };

  const selectedItem = galeria.find(item => item.id === selectedImage);

  return (
    <section id="galeria" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#0066CC]/10 text-[#0066CC] rounded-full text-sm font-semibold mb-4">
            Nuestra Trayectoria
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Galería de Eventos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Revive los momentos más destacados de nuestras capacitaciones, ferias y eventos que han impulsado el crecimiento de las MIPYMES del Valle de Sula.
          </p>
        </div>

        {/* Filtros */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categorias.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveFilter(cat.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeFilter === cat.id
                  ? 'bg-[#0066CC] text-white shadow-lg shadow-[#0066CC]/30'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Grid de Galería */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredGaleria.map((item, index) => (
            <div
              key={item.id}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              onClick={() => setSelectedImage(item.id)}
            >
              <div className={`relative ${index === 0 ? 'h-[500px]' : 'h-[280px]'} w-full`}>
                <img
                  src={item.imagen}
                  alt={item.titulo}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
                
                {/* Badge de categoría */}
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-800 text-xs font-semibold rounded-full capitalize">
                    {item.categoria}
                  </span>
                </div>

                {/* Icono de zoom */}
                <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-zoom-in-line text-white text-xl"></i>
                </div>

                {/* Contenido */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className={`font-bold text-white mb-2 ${index === 0 ? 'text-2xl' : 'text-lg'}`}>
                    {item.titulo}
                  </h3>
                  <p className={`text-white/80 leading-relaxed ${index === 0 ? 'text-base' : 'text-sm line-clamp-2'}`}>
                    {item.descripcion}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Estadísticas */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-[#0066CC]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-event-line text-3xl text-[#0066CC]"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">150+</div>
            <div className="text-gray-600">Eventos Realizados</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-[#00875A]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-star-line text-3xl text-[#00875A]"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">3,500+</div>
            <div className="text-gray-600">Participantes</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-[#E67E22]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-presentation-line text-3xl text-[#E67E22]"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">85+</div>
            <div className="text-gray-600">Capacitaciones</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-[#8E44AD]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-store-3-line text-3xl text-[#8E44AD]"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">25+</div>
            <div className="text-gray-600">Ferias Comerciales</div>
          </div>
        </div>
      </div>

      {/* Modal de imagen ampliada */}
      {selectedImage !== null && selectedItem && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); navigateImage('prev'); }}
            className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-white text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); navigateImage('next'); }}
            className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-white text-2xl"></i>
          </button>

          <div 
            className="max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={selectedItem.imagen}
                alt={selectedItem.titulo}
                className="w-full h-auto max-h-[70vh] object-contain bg-black"
              />
            </div>
            <div className="mt-6 text-center">
              <span className="inline-block px-4 py-1 bg-[#0066CC] text-white text-sm rounded-full mb-3 capitalize">
                {selectedItem.categoria}
              </span>
              <h3 className="text-2xl font-bold text-white mb-2">{selectedItem.titulo}</h3>
              <p className="text-white/70 mb-2">
                <i className="ri-calendar-line mr-2"></i>{selectedItem.fecha}
              </p>
              <p className="text-white/80 max-w-2xl mx-auto">{selectedItem.descripcion}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
